module.exports = __webpack_public_path__ + "static/media/circle_plane.5fa3da2a.svg";